<div class="container py-4">
  <div class="text-center mb-4">
    <h3 class="fw-bold">Plan List</h3>
  </div>

  <!-- Loading -->
  @if (loading) {
  <div class="text-center my-5">
    <div class="spinner-border text-warning"></div>
    <div class="mt-2 small text-muted">Loading plans...</div>
  </div>
  }

  <!-- No Data -->
  @if (!loading && !filteredPayments.length) {
  <div class="text-center text-muted py-5">
    No plan found.
  </div>
  }

  <!-- Table -->
  @if (!loading && filteredPayments.length) {
  <div class="table-responsive">
    <table class="table table-hover table-sm align-middle border mb-0">
      <thead class="table-light">
        <tr class="text-nowrap">
          <th>Product Name</th>
          <th class="text-center">Product ID</th>
          <th class="text-center">Plan ID</th>
          <th class="text-end">Amount</th>
          <th class="text-center">Currency</th>
          <th class="text-center">Frequency</th>
          <th>Remark</th>
          <th class="text-center">Disable</th>
        </tr>
      </thead>
      <tbody>
        @for (p of pagedPayments; track p) {
        <tr>
          <td class="text-center ">
            <div class="d-fle align-items-center">
              <span class="fw-semibold">{{ p.payerName || "Unknown" }}</span>
            </div>
          </td>
          <td class="small text-muted text-center text-break">
            {{ p.paypalId || "-" }}
          </td>
          <td class="small text-muted text-center text-break">
            {{ p.planId || "-" }}
          </td>
          <td class="fw-bold text-end">
            {{ p.amount != null ? (p.amount | number : "1.2-2") : "-" }}
          </td>
          <td class="small text-muted text-center">
            {{ p.currency || "-" }}
          </td>
          <td class="small text-muted text-center">
            {{ p.frequency || "-" }}
          </td>
          <td class="small text-muted text-break">
            {{ p.remark || "No Remark" }}
          </td>
          <td class="text-center">
            @if (p.planStatus === 'ACTIVE') {
            <button class="btn btn-link p-0 text-danger text-decoration-none" title="Delete plan"
              aria-label="Delete plan" [disabled]="deletingMap[p.planId || '']" (click)="onDeletePlanClick(p.planId)">
              @if (!deletingMap[p.planId || '']) {
              <span>
                <i class="fa-solid fa-trash-can text-warning"></i>
              </span>
              }
              <!-- deleting state: small red spinner -->
              @if (deletingMap[p.planId || '']) {
              <span>
                <span class="spinner-border spinner-border-sm text-warning" role="status" aria-hidden="true"></span>
              </span>
              }
            </button>
            } @else {
            <span class="text-muted small">—</span>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  <!-- Pagination -->
  @if (!loading && totalPages > 1) {
  <nav class="mt-3">
    <ul class="pagination justify-content-center pagination-sm">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="prevPage()">Prev</button>
      </li>
      @for (page of pages; track page) {
      <li class="page-item" [class.active]="currentPage === page">
        <button class="page-link" (click)="goToPage(page)">
          {{ page }}
        </button>
      </li>
      }
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="nextPage()">Next</button>
      </li>
    </ul>
  </nav>
  }
  <app-confirm-dialog [show]="showDeleteModal" title="Confirm Deactivate"
    message="Are you sure you want to deactivate this plan?" [subtext]="modalPlanLabel" [busy]="isDeleting"
    [error]="modalError" confirmText="Deactivate" (confirm)="confirmDelete()"
    (cancel)="closeDeleteModal()"></app-confirm-dialog>
</div>